import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './work-details.styles.js'

import Paper from 'pobble-components/dist/paper'

import Container from '../../shared/container/container.jsx'
import Main from '../../shared/main/main.jsx'

import WorkDetailsForm from './work-details-form/work-details-form.container'
import SectionTitle from '../../shared/section-title/section-title.jsx'

class WorksDetails extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    const { classes } = this.props
    return (
      <Container>
        <Main>
          <Paper className={classes.container}>
            <SectionTitle title="Work details" />
            <WorkDetailsForm />
          </Paper>
        </Main>
      </Container>
    )
  }
}

export default injectSheet(styles)(WorksDetails)
